import PengajuanIndex from "@/components/addcost/pengajuan/pengajuanIndex.vue";
import PengajuanAddCostAdd from "@/components/addcost/pengajuan/pengajuanAdd.vue";
import PengajuanAddCostEdit from "@/components/addcost/pengajuan/pengajuanEdit.vue";
import PengajuanAddCostDetail from "@/components/addcost/pengajuan/pengajuanDetail.vue";


let routesPengajuan = [
  {
    path: '', // child default
    name: "pengajuanaddcost",
    component: PengajuanIndex
  },
  {
      path: 'add', // child default
      name: "pengajuanAddCostAdd",
      component: PengajuanAddCostAdd
  },

   {
      path: 'detail/:id', // child default
      name: "pengajuanAddCostDetail",
      component: PengajuanAddCostDetail
    },
     {
      path: 'edit/:id', // child default
      name: "pengajuanAddCostEdit",
      component: PengajuanAddCostEdit
    },
    
 
];

export default routesPengajuan;